"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testType = void 0;
/**
 * Test utilities for types.
 *
 * This is designed specifically for testing.
 * The return value is the input `expected` parameter asserted as the first type parameter,
 * so that the type can be further inspected.
 */
exports.testType = new Proxy({}, {
    get(_target, _prop, _receiver) {
        return (expected) => expected;
    }
});
//# sourceMappingURL=test_type.js.map